import React from 'react';
import {
  Grid,
  Typography,
  TextField,
  Icon,
  IconButton,
  Switch,
  FormControlLabel,
} from '@material-ui/core';


const SetupDiscounts = ({ setupData, editTitle, editOption, addOption, removeOption }) => {
  const {discount} = setupData;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={12}>
        <Typography variant="h4" className="text-brand ml-4 mt-8">Setup Discounts</Typography>
      </Grid>
      {discount &&
      <Grid item xs={12} sm={6}>
        <TextField
          variant="outlined"
          defaultValue={discount.title}
          onBlur={(e) => editTitle('discount', e.target.value)}
          fullWidth
          label={
            <div className="flex items-center">
              Title
            </div>
          }
        />
      </Grid>}
      {!discount?.options?.length &&
      <IconButton
        onClick={() => addOption('discount')}
        title="Add"
      >
        <Icon>add</Icon>
      </IconButton>}
      {discount.options && discount.options.map((option, idx) => (
        <Grid key={option._id || option.id} item xs={12} sm={12} className="flex">
          <TextField
            variant="outlined"
            defaultValue={option.label}
            name="label"
            onBlur={(e) => editOption(e, 'discount', idx)}
            fullWidth
            label={
              <div className="flex items-center">
                Label
              </div>
            }
            helperText={!discount.options[idx]?.label && 'Field is required'}
            error={!discount.options[idx]?.label?.length}
          />
          <TextField
            className="ml-4"
            variant="outlined"
            type="number"
            name="price"
            defaultValue={option.price}
            onBlur={(e) => editOption(e, 'discount', idx)}
            label={
              <div className="flex items-center">
                Price
              </div>
            }
            helperText={!discount.options[idx]?.price?.toString().length && 'Field is required'}
            error={!discount.options[idx]?.price?.toString().length}
          />
          <FormControlLabel
            control={
              <Switch
                onChange={(e) => editOption(e, 'discount', idx)}
                checked={option.isOneTime}
                color="primary"
                name="isOneTime"
                className="ml-2"
              />}
            label="isOneTime"
            labelPlacement="top"
          />
          <IconButton
            onClick={() => removeOption('discount', idx)}
            title="Delete"
            className="h-50px"
          >
            <Icon>delete</Icon>
          </IconButton>
          <IconButton
            onClick={() => addOption('discount', idx)}
            title="Add"
            className="h-50px"
          >
            <Icon>add</Icon>
          </IconButton>
        </Grid>
      ))}
    </Grid>
  );
};

export default SetupDiscounts;
